import axios from "../libs/axios/axios-organisationsupload";
import { BaseBulkUploadService } from "./basebulkupload.service";

export const api = new BaseBulkUploadService(axios);
